import { action } from 'typesafe-actions';
import { ThemeType } from './types';

export const setThemeRequest = () => action(ThemeType.SET_THEME_RESQUEST, {});

export const setThemeSuccess = () => action(ThemeType.SET_THEME_SUCCESS, {});
